"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siloConfigTypes = void 0;
exports.siloConfigTypes = {
    SET_ERROR: 'CONFIGURATION SILO TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'CONFIGURATION SILO TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'CONFIGURATION SILO TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'CONFIGURATION SILO TYPES ON MUTATION',
    ON_SORT_CHANGE: 'CONFIGURATION SILO TYPES ON SORT CHANGE',
    ON_FILTER_CHANGE: 'CONFIGURATION SILO TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'CONFIGURATION SILO TYPES ON SAVE DATAITEM',
    ON_ENTER_EDIT_CLICK: 'CONFIGURATION SILO TYPES ON ENTER EDIT',
    ON_CHANGE_DATAITEM: 'CONFIGURATION SILO TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'CONFIGURATION SILO TYPES SET SUCCESS MODAL',
    SET_DATA_BRAND: 'CONFIGURATION SILO TYPES SET DATA BRAND'
};
